const TOKENS = { email: 'email', name: 'name' };

// A section keeps browser autofill from filling a guest row with the booker's details.
export default function fieldAutoComplete(field) {
  const token = TOKENS[field.type];
  if (!token) return undefined;
  return field.autoCompleteSection ? `section-${field.autoCompleteSection} ${token}` : token;
}
